import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";

const Container = styled.div`
  padding: 0px 6px;
  border-radius: 6px;
  cursor: default;
  display: flex;
  align-items: center;
  height: 18px;
`;

const TextContainer = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${colours.th1};
`;

interface IProps {
  color: string;
  helpText?: string;
  children: any;
}

function Badge({ color, helpText, children }: IProps) {
  return (
    <Container title={helpText} style={{ backgroundColor: color }}>
      <TextContainer>{children}</TextContainer>
    </Container>
  );
}

export default Badge;
